// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3TDc7","list":"PatternAutocomplete_list__8VZXj"};